"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
function DraggableBox(props) {
    var children = props.children, draggableId = props.draggableId, index = props.index, _a = props.notDraggable, notDraggable = _a === void 0 ? false : _a;
    if (notDraggable) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Draggable, { draggableId: draggableId, index: index, children: function (draggableProvided) {
            var dragInnerRef = draggableProvided.innerRef, draggableProps = draggableProvided.draggableProps, dragHandleProps = draggableProvided.dragHandleProps;
            return ((0, jsx_runtime_1.jsx)(children.type, __assign({}, draggableProps, dragHandleProps, children.props, { ref: dragInnerRef, innerRef: dragInnerRef })));
        } }));
}
exports.DraggableBox = DraggableBox;
